// Staging (docs/STAGING.md): båndet "STAGING – testdata" øverst, knappen "Nulstil testdata" (konsollen og Indstillinger) og
// rollebjælken "Test [Ejer ▾] Nulstil" (som i testversionen). Vises kun, når appen er bygget mod Supabase-projektet Freemi Staging
// (deploy previews og branch deploys) – i produktionen er STAGING altid false, og edge-funktionen staging-rolle findes ikke.
import { useState } from 'react';
import type { Bruger } from './api/api';
import { STAGING } from './pixieVaert';
import { STAGING_ROLLER, type StagingRolle } from '../core/staging';
import { Bekraeft, fejlTekst, useApi, visToast } from './lib';

export function StagingBaand() {
  if (!STAGING) return null;
  return <div className="stg-baand" role="status">STAGING – testdata<span className="stg-ekstra"> · intet sendes til kunder · nulstilles hver nat</span></div>;
}

const NULSTIL_TEKST = 'Alle data på staging slettes og laves forfra: virksomheder, kunder, bookinger, betalinger og ændringer, du har lavet. Login-brugerne bevares.';

export function StagingNulstil() {
  const api = useApi();
  const [spoerg, setSpoerg] = useState(false);
  if (!STAGING || !api.stagingNulstil) return null;
  return (
    <div className="stg-nulstil" role="region" aria-label="Testdata">
      <div className="fyld"><b>Testdata (staging)</b><span>500 opdigtede kunder og ~1.500 bookinger. Nulstilles automatisk hver nat.</span></div>
      <button className="knap sekundaer lille" onClick={() => setSpoerg(true)}>Nulstil testdata</button>
      {spoerg && <Bekraeft titel="Nulstil testdata?" knap="Nulstil" fare luk={() => setSpoerg(false)} tekst={NULSTIL_TEKST}
        ok={async () => { await api.stagingNulstil!(); location.reload(); }} />}
    </div>
  );
}

/**
 * Rollebjælken på staging: skift mellem test-brugerne (ejer, admin, kontor, sælger, steamer 1 og 2, kunde) uden adgangskode.
 * Kræver, at man er logget ind som en af test-brugerne (fx med sit eget staging-login første gang). "Nulstil" kræver ejer/admin.
 */
export function StagingBjaelke({ bruger, rute }: { bruger: Bruger | null; rute: string }) {
  const api = useApi();
  const [nulstil, setNulstil] = useState(false);
  const [skifter, setSkifter] = useState(false);
  if (!STAGING || !api.stagingSkiftRolle || !bruger) return null;
  // Test-brugernes mail er <rolle>@example.com (supabase/staging/staging.sql)
  const vaerdi = STAGING_ROLLER.find((r) => bruger.email?.toLowerCase() === `${r.id}@example.com`)?.id ?? 'anden';
  const kanNulstille = bruger.rolle === 'ejer' || bruger.rolle === 'admin';
  const harBund = rute.startsWith('/admin') || rute.startsWith('/steamer') || rute.startsWith('/mine');
  const skift = async (rolle: StagingRolle) => {
    setSkifter(true);
    try { await api.stagingSkiftRolle!(rolle); }   // siden åbnes forfra som den nye rolle
    catch (e) { visToast(fejlTekst(e)); setSkifter(false); }
  };
  return (
    <div className={'demo-bjaelke stg-bjaelke' + (harBund ? ' over-bund' : '') + (/\/chat\/./.test(rute) ? ' oppe' : '')} aria-label="Staging: skift rolle">
      <span>Test</span>
      <select aria-label="Skift rolle" value={vaerdi} disabled={skifter} onChange={(e) => void skift(e.target.value as StagingRolle)}>
        {vaerdi === 'anden' && <option value="anden">{bruger.navn}</option>}
        {STAGING_ROLLER.map((r) => <option key={r.id} value={r.id}>{r.navn}</option>)}
      </select>
      <button disabled={!kanNulstille} title={kanNulstille ? undefined : 'Skift til Ejer eller Admin for at nulstille testdata'} onClick={() => setNulstil(true)}>Nulstil</button>
      {nulstil && <Bekraeft titel="Nulstil testdata?" knap="Nulstil" fare luk={() => setNulstil(false)} tekst={NULSTIL_TEKST}
        ok={async () => { await api.stagingNulstil!(); location.reload(); }} />}
    </div>
  );
}
